module.exports = __webpack_public_path__ + "static/img/7.e4dc1da8.jpg";